import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useMsal } from "@azure/msal-react";
import BusinessCentralService from "../services/BusinessCentralService";
import AppLayout from "./AppLayout";
import { getUrlParam } from "../store/helpers";
import HomePage from "../pages/HomePage";
import { getIsCrane } from "../authConfig";
import { useAppContext } from "../store";
import { ACTION_TYPES } from "../store/actions";
import { CircleSpinner } from "../components/CircleSpinner";
const MainContent = () => {
    const { dispatch } = useAppContext();
    const [backendInitialized, setBackendInitialized] = useState(false);
    const { instance } = useMsal();
    const isCrane = getIsCrane();
    const bcService = useMemo(() => new BusinessCentralService(instance), [instance]);
    useEffect(() => {
        const loadWebServiceConfigs = async () => {
            const customWindow = window;
            customWindow.loginConfig = customWindow.loginConfig ?? {};
            const tenantId = getUrlParam("tenantId");
            const environment = getUrlParam("environment");
            const company = getUrlParam("company");
            const posUnit = getUrlParam("posUnit");
            if (isCrane) {
                const posUnit = customWindow.loginConfig?.onPremiseConfig?.posUnit;
                if (!posUnit) {
                    console.error("Missing posUnit in onPremiseConfig");
                    return;
                }
                setBackendInitialized(true);
                return;
            }
            customWindow.loginConfig.cloudConfig = {
                tenantId: tenantId ?? "",
                environment: environment ?? "",
                company: company ?? "",
                posUnit: posUnit ?? "",
            };
            await bcService.getAccessToken();
            setBackendInitialized(true);
        };
        loadWebServiceConfigs();
    }, [bcService]);
    useEffect(() => {
        const intervalId = setInterval(() => {
            // eslint-disable-next-line no-console
            console.info("Rotating OAuth token.");
            bcService.getAccessToken();
        }, 15 * 60 * 1000);
        return () => clearInterval(intervalId);
    }, [bcService]);
    useEffect(() => {
        const language = getUrlParam("lang") ?? "en";
        dispatch({
            type: ACTION_TYPES.SET_LANGUAGE,
            payload: language,
        });
    }, [dispatch]);
    if (!backendInitialized) {
        return (_jsx("div", { className: "flex items-center justify-center h-screen", children: _jsx(CircleSpinner, {}) }));
    }
    return (_jsx(AppLayout, { children: _jsx(HomePage, {}) }));
};
export default MainContent;
